import { darkTheme } from '@/constants/theme'

export const useTheme = () => {
  // For now, always return dark theme
  // In future, this could be configurable
  return darkTheme
}
